import Utils from "common/utils";
import { Promise } from "es6-promise";
import Analytics from "analytics";
import Constants from 'common/constants'
import ListenerManager from 'manager/listenerManager'

class SidebarStateStore {
    constructor() {
        // Take it from a constant or something
        this.__isSidebarOpen = false
        this.__listeners = new ListenerManager()
    }

    registerForStateChange(cb) {
        if (Utils.isNull(cb)) {
            return null
        }
        return this.__listeners.addListener(cb)
    }

    unregisterListenerForKey(key) {
        if (Utils.isNull(key)) {
            return false
        }
        return this.__listeners.removeListener(key)
    }

    getIsSidebarOpen() {
        return this.__isSidebarOpen
    }

    setIsSidebarOpen(newState) {
        if (Utils.isNull(newState)) {
            return false
        }

        this.__isSidebarOpen = newState

        // Call all callbacks async
        new Promise((resolve, reject) => {
            if (Utils.isNull(this.__listeners) || this.__listeners.length() <= 0) {
                resolve()
                return
            }

            this.__listeners.getAllListeners().forEach((cb) => {
                try {
                    cb()
                } catch (err) {
                    console.log("[SIDEBAR-STATE] Error executing callback - ", err)
                }
            })

            // Send to analytics 
            let action = (this.__isSidebarOpen === true) ?
                Constants.ANALYTICS.EVENTS.ACTION.SIDEBAR_OPEN : Constants.ANALYTICS.EVENTS.ACTION.SIDEBAR_CLOSE;

            Analytics.sendEvent(
                Constants.ANALYTICS.EVENTS.CATEGORY.SIDEBAR,
                action,
            )
            resolve()
        })
        return true
    }
}

let instance = new SidebarStateStore()
export default instance


// WEBPACK FOOTER //
// ./src/stores/sidebarStateStore.js